const ID = '1602'

export const WHY_CHAT_ME_ID = `why-chat-me-${ID}`
export const BENEFITS_ID = `benefits-${ID}`
export const INTEGRATION_ID = `integration-${ID}`